import React from 'react';
import {Loader2, Sparkles} from 'lucide-react';
import {brand, brandFont} from '../../brand';

export const CreateTimerButton: React.FC<{isCreating: boolean; frame: number}> = ({
  isCreating,
  frame,
}) => {
  const spinDeg = (frame * 360) / 30;
  const fg = isCreating ? 'rgba(255,255,255,0.62)' : 'rgba(255,255,255,0.98)';
  return (
    <div
      style={{
        padding: '24px 28px',
        borderRadius: 28,
        background: isCreating ? 'rgba(255,255,255,0.12)' : brand.primaryLight,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 14,
        fontFamily: brandFont,
        fontWeight: 600,
        fontSize: 26,
        color: fg,
      }}
    >
      {isCreating ? (
        <span
          style={{
            display: 'inline-flex',
            transform: `rotate(${spinDeg}deg)`,
          }}
        >
          <Loader2 size={26} color={fg} strokeWidth={2.6} />
        </span>
      ) : (
        <Sparkles size={26} color={fg} strokeWidth={2.4} />
      )}
      {isCreating ? 'Creating...' : 'Create timer'}
    </div>
  );
};
